import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class TVIcon extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        size: PropTypes.number
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondaryColor: '#fff',
        size: 50
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 218.69">
                <rect width={300} height={186.75} rx={15} ry={15} fill={color} />
                <path
                    d="M274.33 174.11H25.67a13.62 13.62 0 0 1-13.6-13.6V26.24a13.62 13.62 0 0 1 13.6-13.6h248.66a13.62 13.62 0 0 1 13.61 13.6V160.5a13.62 13.62 0 0 1-13.61 13.61zM25.67 19.73a6.51 6.51 0 0 0-6.51 6.51V160.5a6.51 6.51 0 0 0 6.51 6.51h248.66a6.52 6.52 0 0 0 6.51-6.51V26.24a6.52 6.52 0 0 0-6.51-6.51z"
                    fill={secondaryColor}
                />
                <path
                    d="M211.7 218.68H88.3c-4.9 0-8.87-2.42-8.87-5.41v-9.15c0-3 4-5.41 8.87-5.41h123.4c4.9 0 8.87 2.43 8.87 5.41v9.15c0 3-4 5.41-8.87 5.41"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(TVIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/TVIcon.js